import * as React from "react";

export default () => {
  return (
    <div>
      Lägg till kostnader och rabatter för avtalet.
      <br />
      <br />
    </div>
  );
};
